import { IconButton, Typography } from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';

import PickerLogo from 'assets/icons/PickerLogoB';
import PickerLogoInverted from 'assets/icons/PickerLogoW';

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'drawerWidth',
})(({ theme, open, drawerWidth }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  boxShadow: 'none',
}));

export const PickerLogoTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.title,
  textDecoration: 'none',
  marginLeft: '10px',
  fontSize: '1.5rem',
  fontWeight: '500',
}));

export const StyledPickerLogo = styled(PickerLogo)(({ theme }) => ({
  width: '150px',
  [theme.breakpoints.down('md')]: {
    width: '110px',
  },
}));

export const StyledPickerLogoInverted = styled(PickerLogoInverted)(
  ({ theme }) => ({
    width: '150px',
    [theme.breakpoints.down('md')]: {
      width: '110px',
    },
  })
);

export const CustomIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'darkMode',
})(({ darkMode }) => ({
  opacity: 0.6,

  '&:hover': {
    opacity: 1,
    color: darkMode.value ? '#1a73e8' : '#FFC300',
  },

  '&:active': {
    opacity: 1,
    color: darkMode.value ? '#1a73e8' : '#FFC300',
  },
}));

export const StyledImage = styled('img')({
  height: '45px',
  objectFit: 'contain',
});
